import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token'); // Token'ı nerede saklıyorsanız oradan alın

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decoded = jwtDecode(token);
    const userRole = decoded.role; // JWT içindeki role key'ine göre güncelleyin

    if (!allowedRoles.includes(userRole)) {
      // Yetkisi yoksa ana sayfaya veya hata sayfasına yönlendir
      return <Navigate to="/" replace />;
    }

    return children;
  } catch (error) {
    // Token geçersizse login'e gönder
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;